export const isInIframe = () => {
  if (typeof window === "undefined") return false;

  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const isPreviewHost = () => {
  if (typeof window === "undefined") return false;

  const hostname = window.location.hostname;
  return hostname.includes("id-preview--") || hostname.includes("lovableproject.com");
};

export const shouldDisableServiceWorker = () => isInIframe() || isPreviewHost();

export const unregisterServiceWorkers = async () => {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));
};
